import React, { useState, useEffect } from 'react'
import {Input, Col, Row, Form, Checkbox, notification, Select, Button, Tooltip} from 'antd';
import {PlusOutlined, QuestionCircleOutlined} from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive';
import RequestHandler from '../../util/RequestHandler';

const layout = {
  labelCol: {
    span: 10,
  },
  wrapperCol: {
    span: 11,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const TenantPaymentAccountUpdate = (props) => {
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-device-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({ query: '(max-device-width: 1224px)' });

  const [loading, setLoading] = useState(false);
  const [bankId, setbankId] = useState(props.bankId);
  const [iban, setiban] = useState(props.iban);
  const [bankBranchName, setbankBranchName] = useState(props.bankBranchName);
  const [accountNumber, setaccountNumber] = useState(props.accountNumber);
  const [name, setName] = useState(props.name);
  const [isDefault, setisDefault] = useState(props.isDefault);
  const [bankDropdown, setbankDropdown] = useState([]);

  const [isForeignCurrencySupported, setIsForeignCurrencySupported] = useState(false);
  const [currencyId, setCurrencyId] = useState(props.currencyId);

  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: false,
  });

  const [bankBranchDropdownUpdate, setbankBranchDropdownUpdate] = useState([]);
  useEffect(() => {
    RequestHandler.get(`/BankBranch/GetBranchForBank?id=${props.bankId}`).then(response => {
      setbankBranchDropdownUpdate(response);
    });

    setbankBranchName(props.bankBranchName);
    setName(props.name);
    setiban(props.iban);
    setisDefault(props.isDefault);
    setCurrencyId(props.currencyId);


    RequestHandler.get(`/Bank`).then(response => {
      setbankDropdown(response.value.filter(x => x.isTosSupport === true));
    });
  }, [setbankDropdown, setbankId, setName, setiban, setisDefault, props.accountNumber, props.name, props.firmDropdown, props.firmId, props.bankId, props.bankDropdown, props.bankBranchName, props.iban, props.isDefault, props.currencyId]
  );

    useEffect(() => {

    const bank = bankDropdown.filter(x => x.id == props.bankId);

    if(bank.length > 0) {
      setIsForeignCurrencySupported(bank[0].isTosForeignCurrencySupported);
      getCurrencies();
    }


  }, [bankDropdown])


  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });
    RequestHandler.get(`/Currency?$select=id,code,name`).then((response) => {
      setCurrencySelect({
        data: response.value,
        loading: false,
      });
    });
  };


  const openNotificationWithIconUpdate = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Güncelleme işlemi başarı ile gerçekleşti.',
      duration: 2,
    });
  };

  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Ekleme işlemi başarı ile gerçekleşti.',
      duration: 2,
    });
  };

  const onFinishAdd = values => {
    RequestHandler.put(`/TenantPaymentAccount`, {
      bankId: props.bankId,
      name: values.Name,
      bankBranchId: values.bankBranchId,
      accountNumber: values.AccountNumber,
      iban: values.Iban,
      isDefault: values.IsDefault === null || values.IsDefault == undefined ? false : values.IsDefault
    }, false, { rawResponse: true }).then(res => {
      if (res.status === 200) {
        openNotificationWithIcon('success');
        setTimeout(function () {
          window.location.reload();
        }.bind(this), 2000);
      }else{
        setLoading(false)
      }
    }).catch(function (e) {
      setLoading(false);
    });
  }

  const onFinishUpdate = values => {
    RequestHandler.put(`/TenantPaymentAccount`, {
      id: props.firmAccountId,
      bankId: props.bankId,
      name: values.Name,
      bankBranchId: values.BankBranchId,
      accountNumber: values.AccountNumber,
      iban: values.Iban,
      isDefault: values.IsDefault,
      currencyId:isForeignCurrencySupported ? values.currencyId : 1
    }, false, { rawResponse: true }).then(res => {
      if (res.status == 200) {
        openNotificationWithIconUpdate('success');
        setTimeout(function () {
          props.sendDataForUpdate("success");
          setLoading(false);
        }.bind(this), 2000);
      }else{
        setLoading(false)
      }
    }).catch(function (e) {
      setLoading(false);
    });
  };

  const onFinishFailedUpdate = () => setLoading(false);

  const handleChecked = (e) => setisDefault(e.target.checked);

  const onChange = (value) => {
    RequestHandler.get(`/BankBranch/GetBranchForBank?id=${value}`).then(response => {
      setbankBranchDropdownUpdate(response);
      setbankId(value);
      setbankBranchName('');
    });
  }


  const onChangeCurrency = (value) => {
    setCurrencyId(value);
  }

  const handleAccountNumber = value => setaccountNumber(value.target.value);

  const handleName = value => {
    setName(value.target.value)
  };

  const handleBankBranchId = value => setbankBranchName(value);

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }

  const handleIban = value => {
    setiban(value.target.value)
  };

  const FormItemLabelWithTooltip = ({ label, tooltip }) => {
    return (
      <>
        {label}{" "}
        <Tooltip title={
          <span>
            {tooltip?.split('*').filter(part => part.trim() !== '').map((line, index) => (
              <div key={index}> * {line}</div>
            ))}
          </span>
        } overlayStyle={{ maxWidth: "450px" }}>
          <QuestionCircleOutlined
            className="gx-text-blue"
            style={{ marginLeft: 5,marginRight:3, fontSize: "120%" }}
          />
        </Tooltip>
      </>
    );
  };

  const { Option } = Select;
  return (
    <div>
      <Form
        {...layout}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={props.AccountId !== undefined ? onFinishAdd : onFinishUpdate}
        onFinishFailed={onFinishFailedUpdate}
        fields={[
          { name: "Name", value: name },
          { name: "BankId", value: bankId },
          { name: "Iban", value: iban },
          { name: "BankBranchId", value: bankBranchName },
          { name: "AccountNumber", value: accountNumber },
          { name: "IsDefault", value: isDefault },
          { name: "currencyId", value: currencyId}
        ]}
      >
        <Row>
          {isDesktopOrLaptop && <>
            <Col span={24}>
              <Form.Item
                label="Hesap Adı"
                name="Name"
              >
                <Input
                  value={name}
                  onChange={handleName} />
              </Form.Item>

              <Form.Item
                label="Banka"
                name="BankId"
                rules={[
                  {
                    required: true,
                    message: 'Lütfen banka alanını boş bırakmayın.',
                  },
                ]}
              >
                <Select
                  showSearch
                  disabled
                  placeholder="Seçiniz."
                  optionFilterProp="children"
                  onChange={onChange}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {bankDropdown.map(item => (
                    item.Name === "KASA HESABI" ? "" :
                      <Option key={item.id}>{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="IBAN"
                name="Iban"
                rules={
                  [
                    {
                      required: true,
                      message: 'Lütfen Iban alanını boş bırakmayın.',
                    },
                  ]}
              >
                <Input type="text" maxLength="26" value={iban} onChange={handleIban} />
              </Form.Item>
              <Form.Item
                label="Banka Şubesi"
                name="BankBranchId"
                rules={
                  [
                    {
                      required: true,
                      message: 'Lütfen banka şubesini seçiniz.',
                    },
                  ]}
              >
                <Select
                  showSearch
                  placeholder="Seçiniz"
                  optionFilterProp="children"
                  onChange={handleBankBranchId}
                  value={bankBranchName}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {bankBranchDropdownUpdate.map(item => (
                    <Option key={item.id}>{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Hesap Numarası"
                name="AccountNumber"
                rules={
                  [
                    {
                      required: true,
                      message: 'Lütfen hesap numarası alanını boş bırakmayın.',
                    },
                  ]}
              >
                <Input maxLength="17" onInput={maxLengthCheck}
                  value={accountNumber}
                  onChange={handleAccountNumber} />
              </Form.Item>

              {isForeignCurrencySupported ? <>
                <Form.Item
                  name="currencyId"
                  label="Para Birimi"
                  initialValue={1}
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                    placeholder="Seçiniz"
                    loading={currencySelect.loading}
                    onChange={onChangeCurrency}
                  >
                    {currencySelect.data.map((item) => (
                      <Select.Option key={item.id} value={item.id}>
                        {`${item.code} (${item.name})`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </>:<></> }


              <Form.Item
                label= {
                  <FormItemLabelWithTooltip
                    label="Geçerli Hesap"
                    tooltip="Yalnızca 1 adet hesap geçerli olabilir, seçtiğinizde ödeme ekranında default seçili gelmesini sağlar."
                  />
                }
                name="IsDefault"
                valuePropName="checked"
              >
                <Checkbox onChange={handleChecked} />
              </Form.Item>
            </Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={3}>
              <Form.Item {...tailLayout} >
                <Button type="primary" icon={<PlusOutlined />} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                  {props.AccountId !== undefined ? "Ekle" : "Güncelle"}
                </Button>
              </Form.Item>
            </Col>
            <Col span={3}></Col>
          </>}
          {isTabletOrMobileDevice && <>
            <Col span={24}>
              <Form.Item
                label="Hesap Adı"
                name="Name"
              >
                <Input
                  value={name}
                  onChange={handleName} />
              </Form.Item>


              <Form.Item
                label="IBAN"
                name="Iban"
                rules={[
                  {
                    required: true,
                    message: 'Lütfen Iban alanını boş bırakmayın.',
                  },
                ]}
              >
                <Input type="text" maxLength="26" value={iban} onChange={handleIban} />
              </Form.Item>

              <Form.Item
                label="Banka Şubesi"
                name="BankBranchId"
              >
                <Select
                  showSearch
                  placeholder="Seçiniz"
                  optionFilterProp="children"
                  onChange={handleBankBranchId}
                  value={bankBranchName}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {bankBranchDropdownUpdate.map(item => (
                    <Option key={item.id}>{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Hesap Numarası"
                name="AccountNumber"
              >
                <Input maxLength="17" onInput={maxLengthCheck}
                  value={accountNumber}
                  onChange={handleAccountNumber} />
              </Form.Item>

              {isForeignCurrencySupported ? <>
                <Form.Item
                  name="currencyId"
                  label="Para Birimi"
                  initialValue={1}
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                    placeholder="Seçiniz"
                    loading={currencySelect.loading}
                    onChange={onChangeCurrency}
                  >
                    {currencySelect.data.map((item) => (
                      <Select.Option key={item.id} value={item.id}>
                        {`${item.code} (${item.name})`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </>:<></> }

              <Form.Item
                label="Geçerli Hesap"
                name="IsDefault"
                valuePropName="checked"
              >
                <Checkbox onChange={handleChecked} />
              </Form.Item>
            </Col>
            <Col span={10}></Col>
            <Col span={8}>
              <Form.Item {...tailLayout} >

                <Button type="primary" icon={<PlusOutlined />} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                  {props.AccountId !== undefined ? "Ekle" : "Güncelle"}
                </Button>
              </Form.Item>
            </Col>
            <Col span={6}></Col>
          </>}

        </Row>
      </Form>
    </div>
  )
}

export default TenantPaymentAccountUpdate;
